import { render } from "./EmployeeImmigration.vue?vue&type=template&id=6e5890aa&scoped=true"
import script from "./EmployeeImmigration.vue?vue&type=script&lang=js"
export * from "./EmployeeImmigration.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=6e5890aa&lang=scss&scoped=true"
import "./EmployeeImmigration.vue?vue&type=style&index=1&id=6e5890aa&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5890aa"]])

export default __exports__